import { gql } from '@apollo/client';
import { BLOCK_FRAGMENT } from './block.newsletter.graphql';

export const SECTION_FRAGMENT = gql`
  fragment Section on Section {
    id
    title
    position
    url
    createdAt
    updatedAt
    blocks(first: 200, orderBy: position_ASC) {
      ...Block
    }
  }
  ${BLOCK_FRAGMENT}
`;
